var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.75c0 .438.313.75.75.75H13V6c0 .688.781 1 1.25.531l2.5-2.5a.684.684 0 0 0 0-1.031L14.25.5C13.781 0 13 .344 13 1v1.5H1.75a.74.74 0 0 0-.75.75v.5ZM16.25 8.5H5V7c0-.656-.813-1-1.281-.5L1.219 9a.684.684 0 0 0 0 1.031l2.5 2.5C4.188 13 5 12.687 5 12v-1.5h11.25a.74.74 0 0 0 .75-.75v-.5a.76.76 0 0 0-.75-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.e4d2d0e2e2a76d19c434c6283f824cd8.svg";
export { ForwardRef as ReactComponent };